/*
 * @Author: your name
 * @Date: 2021-09-06 09:49:03
 * @LastEditTime: 2021-09-24 11:28:27
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\api\index\indexApi.js
 */
import { postFetch, getFetch } from '@/utils/request'

// index/getConsumablesRecommendKeyWord 获取耗材推荐关键词
export function getConsumablesKeyWord() {
    return getFetch('/index/getConsumablesRecommendKeyWord')
}

// index/getInstrumentRecommendKeyWord 获取仪器推荐关键词
export function getInstrumentKeyWord() {
    return getFetch('/index/getInstrumentRecommendKeyWord')
}

// index/getReagentRecommendKeyWord 获取试剂推荐关键词
export function getReagentKeyWord() {
    return getFetch('/index/getReagentRecommendKeyWord')
}

// index/getRecommendKeyWord 获取推荐关键词
export function getRecommendKeyWord() {
    return getFetch('/index/getRecommendKeyWord')
}


// WEBPACK FOOTER //
// ./src/api/index/keyWordsApi.js